import * as React from 'react';
export const mainstreetSvg = React.forwardRef(function mainstreetSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0A1A0C',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M28 7v17.203h-2.18l.225-15.082.004-.04h-.265L24.24 24.204h-2.175l1.902-15.078.005-.043h-.266l-3.222 15.121h-2.175l3.58-15.121h-.266l-5.313 15.12h-.622L10.385 9.11l-.008-.027h-.269l3.584 15.121h-2.175L8.298 9.113l-.004-.031h-.269l1.907 15.121H7.757L6.219 9.117l-.004-.035H5.95l.225 15.121H4V7h7.453l4.258 12.215.008.023h.558L20.543 7H28Z',
      fill: '#ACE119',
    }),
  );
});
mainstreetSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mainstreet = {
  category: 'brand',
  colorable: false,
  name: 'mainstreet',
  svg: mainstreetSvg,
};
